import {FixedVTag} from "../entities/FixedVTag";
import {BaseService} from "./BaseService";
import { StateService } from "@uirouter/angularjs";

export class FixedVTagService extends BaseService<FixedVTag>{
    static $inject = ['$http','$q','$state'];
    constructor($http: ng.IHttpService, $q: ng.IQService, $state: StateService) {
        super($http, $q, $state, FixedVTag);
    }
    protected getBaseUrl():string{
        return "fixedvtag";
    }
    clearAllRtlsInformation():ng.IPromise<any>{
        var config:any = {};
        return this.useDeleteHandler(this.getBasesUrl(),"rtlsInformation", config);
    }
    getBySite(mapSiteId:number):ng.IPromise<FixedVTag[]>{
        return this.useBaseGetArrayHandler(this.getBasesUrl(),"site?siteId="+mapSiteId, {});
    }
    getChangedBySite(mapSiteId:number, lastChecked:string):ng.IPromise<FixedVTag[]>{
        var config:any = {};
        return this.useBaseGetArrayHandler(this.getBasesUrl(),"changed?siteId="+mapSiteId+"&lastChecked="+lastChecked, config);
    }
    getFirstVTagMatch(search:string):ng.IPromise<FixedVTag>{
        var config:any = {};
        return this.useBaseGetHandler(this.getBaseUrl(),"firstVTagMatch?search="+search, config);
    }
}
